import { call, put } from 'redux-saga/effects';
import { ApiError, ApiResponse } from 'store/api/types';
import { RefreshContactRequestAction } from '../types';
import { checkResponse } from 'store/utils';

import { refreshContact } from '../api';
import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import {
  fetchViesContactsRequest,
  refreshContactFailure,
  refreshContactSuccess,
} from '../actions';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* refreshContactSaga(action: RefreshContactRequestAction) {
  try {
    let err: ApiError | null;
    const { contactId, connectionId } = action.payload;

    const response: ApiResponse = yield call(
      refreshContact,
      contactId,
      connectionId
    );
    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    yield put(refreshContactSuccess());
    yield put(fetchViesContactsRequest(connectionId));
    //yield put(fetchContactRequest(contactId));
    const message: MessageData = {
      title: i18n.t('common.success'),
      description: i18n.t('notifications.contact-refreshed'),
      type: MessageStates.SUCCESS,
    };
    yield put(turnMessageOn(message));
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(refreshContactFailure());
  }
}
